import { Form, SubmitFormButton, TextField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Body, Footer, Popup } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetUserQuery } from 'common';
import { useTrackAvailabilityInteraction } from 'hooks/analytics_events/use_track_availability_interaction';
import { useCreateAvailabilityScheduleMutation, useGetAvailabilitySchedulesQuery } from '../../../api';
import { SCHEDULES_PATH } from '../../../constants';
import { getValidationSchema } from '../name_validation_schema';
const initialValues = {
  name: ''
};
const wrapperCss = "w5ohrgm";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const CreateSchedulePopup = () => {
  const history = useHistory();
  const [createAvailabilitySchedule] = useCreateAvailabilityScheduleMutation();
  const trackCreateScheduleSave = useTrackAvailabilityInteraction({
    action: 'create_schedule_save'
  });
  const {
    data: {
      primary_availability_rule_id: defaultScheduleId,
      timezone
    }
  } = useGetUserQuery();
  const {
    data: allSchedules
  } = useGetAvailabilitySchedulesQuery();
  const defaultSchedule = allSchedules.find(({
    id
  }) => id === defaultScheduleId);
  const handleClose = () => history.push(history.location.pathname);
  const handleSubmit = ({
    name
  }) => {
    trackCreateScheduleSave();
    return createAvailabilitySchedule({
      name,
      rules: defaultSchedule.rules,
      timezone,
      onSuccess: ({
        id
      }) => {
        history.push(`${SCHEDULES_PATH}/${id}`);
      }
    });
  };
  return <Popup withCloseButton onClose={handleClose} title={I18n.t('publisher.availability.schedules.new_schedule_popup.create')}>
      <Form initialValues={initialValues} validationSchema={getValidationSchema()} onSubmit={handleSubmit}>
        <Wrapper>
          <Body>
            <TextField placeholder={I18n.t('publisher.availability.schedules.text_field_popup.placeholder')} label={I18n.t('publisher.availability.schedules.schedule_name')} name="name" data-1p-ignore="true" data-lpignore="true" />
          </Body>
          <Footer>
            <Button decoration="secondary-outline" onClick={handleClose}>
              {I18n.t('publisher.action.cancel')}
            </Button>
            <SubmitFormButton>
              {I18n.t('publisher.action.create')}
            </SubmitFormButton>
          </Footer>
        </Wrapper>
      </Form>
    </Popup>;
};

require("./create_schedule_popup.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./create_schedule_popup.js");